module.exports = {
    title: "Resume Plans",
    crud: {
        create: "Create Resume Plan",
        edit: "Edit Resume Plan",
        view: "View Resume Plan",
    },
    table: {
        title:'Title',
        platform:'Platform',
        userType:'User Type',
        skuCode:'SKU Code',
        durationUnit:'Duration Unit',
        durationValue:'Duration Value',
        duration:'Duration',
        freeResumeCount:'Free Count',
        resumeCount:'Count',
        pageCount:'Page Count',
        resumeSummary:'Resume Count',
        isOnetimeDiscountPlan:'Is Discounted Plan',
        createdAt:'Created At',
    },
    form: {
        type: "Type",
        sku_id:'SKU ID',
        subIndustry: "Sub Industry",
        sequence: "Sequence",
        industry: "Industry",
        name: "Name",
        description: "Description",
        platform: "Platform",
        duration: "Duration",
        isOnetimeDiscountPlan:'Is Discounted Plan',
        price: "Price",
        offer_price: "Offer Price",
        country: "Country",
        action: "Action",
        duration_value: "Duration Value",
    },
    validation: {
        required: {
            type: 'Type is required',
            sku_id:'SKU ID is required',
            ai_resume_count: 'AI resume count is required',
            page_count: 'Page count is required',
            name: 'Name is required',
            description: 'Description is required',
            platform: 'Platform is required',
            duration: "Duration  is required",
            country: "Country is required",
            duration_value: "No of duration is required",
            duration_value_min: "No of duration is not less then 0",
            duration_value_max: "No of duration is not grether ",
        }
    },
}
